import { useRef } from 'react';

import { Box } from 'components/Box';
import { Hide } from 'components/Hide';
import { IdealistLogo } from 'components/Logo/IdealistLogo';
import { NoAmp } from 'containers/NoAmp';
import { colors, gutterWidth } from 'theme/theme';

import { MobileSearchMenu } from './MobileSearchMenu';
import { PageHeaderSearchInputs } from './PageHeaderSearchInputs';
import { useStaffSearchMenu } from './useStaffSearchMenu';

type Props = {
  onSearch: (arg0: {
    query?: string;
    type?: string;
    searchType?: string;
  }) => void;
  qaId?: string;
  searchOpen: boolean;
  toggleSearch: (searchOpen: boolean) => void;
};

export function StaffPageHeaderSearchMenu({
  onSearch,
  qaId = 'staff-search-menu',
  searchOpen,
  toggleSearch,
}: Props) {
  const staffProps = useStaffSearchMenu();
  const initialQuery = useRef(staffProps.query).current;

  return (
    <NoAmp>
      <MobileSearchMenu
        onClose={() => toggleSearch(false)}
        onSearch={() => toggleSearch(false)}
        searchOpen={searchOpen}
        selectedType={staffProps.selectedType}
        listingTypes={staffProps.listingTypes}
        clearSearchInput={staffProps.clearSearchInput}
        search={staffProps.search}
        initialQuery={initialQuery}
        query={staffProps.query}
        searchLocation={staffProps.searchLocation || undefined}
        setListingType={staffProps.setListingType}
        setUserQuery={staffProps.setQuery}
        onLocationChange={staffProps.onLocationChange}
      />
      <Hide xs sm md>
        <Box
          data-qa-id={qaId}
          classes={['flex', 'align-center']}
          position="relative"
          width="100%"
          bg="white"
          pb={['36px', null, null, 16]}
          pt={['36px', null, null, 16]}
          px={gutterWidth / 2}
          height="100%"
          borderTop={`1px solid ${colors.inputGrey}`}
        >
          <Box height="100%" mr={[24, null, null, null, 40]}>
            <Box
              component="a"
              href="/staff"
              title="Idealist Staff"
              data-qa-id="header-logo-link"
              display="block"
              height="100%"
              lineHeight={0}
            >
              <IdealistLogo
                withText
                height={{ mobile: 36, desktop: 48 }}
                withStaffMarker
              />
            </Box>
          </Box>

          <Box flex="1 1 auto" width="100%" height="100%">
            <PageHeaderSearchInputs
              onSearch={onSearch}
              selectedType={staffProps.selectedType}
              listingTypes={staffProps.listingTypes}
              clearSearchInput={staffProps.clearSearchInput}
              search={staffProps.search}
              initialQuery={initialQuery}
              query={staffProps.query}
              searchLocation={staffProps.searchLocation}
              setListingType={staffProps.setListingType}
              setQuery={staffProps.setQuery}
              onLocationChange={staffProps.onLocationChange}
              searchInputId="search-query"
              searchInputQaId="search-input"
            />
          </Box>
        </Box>
      </Hide>
    </NoAmp>
  );
}
